import {uploadCanvasJson} from "../api/common";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {defaultShapeUtils, Editor, TLStoreSnapshot} from "@tldraw/tldraw";
import {useLocation, useNavigate} from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import '../styles/chat.scss'
import {deleteLocalStorage, getLocalConversionId, getLocalStorage} from "../util/storage";
import {LoginProps} from "../types/authority";
import {Button} from "@mui/material";
import {notificationService} from "../services/notification";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../store";
import {
    coverSelectCanvasImage,
    setCurrentDialogImageInfo,
    setGlobalMessage,
    setSelectCanvasImage
} from "../store/taskSlice";
import Profile from "../component/tool_bar/profile";
import {setCurrentChatOn, setCurrentImageShape, setCurrentStepId} from "../store/drawSlice";
import {useTranslation} from 'react-i18next'
import {getBoardInfo} from "../api/boardManage";
import {caseBoardInfoProps} from "../types/board.types";
import {setUseSuggestion} from "../store/userSlice";
import LocalMoodBoardComponent from "../components/LocalMoodBoardComponent";
import RemoteInspireBoardComponent from "../components/RemoteInspireBoardComponent";
import {setChangeGuestMode} from "../store/memberSlice";
import CustomerService from "../component/customer_service";
import {IsVisitor} from "../util/author";
import NewUser from "../component/tool_bar/NewUser";
import NotificationService from "../component/notification_service";

export default function Draw(props: {handleSetUserInfo: (data: LoginProps | null) => void, userInfo: LoginProps | null}) {
    const {handleSetUserInfo, userInfo} = props;

    const [loading, setLoading] = useState<boolean>(false);

    const { t } = useTranslation()

    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    const boardId = queryParams.get('boardId');

    const isInspire = queryParams.get('inspire');

    const [openHistoryTab, setOpenHistoryTab] = useState<number>(0);

    const navigate = useNavigate();

    const [editor, setEditor] = useState<Editor>()

    const level2TaskId = useSelector((state: RootState) => state.task.level2TaskId);

    const GuestMode = useSelector((state: RootState) => state.member.GuestMode);

    const dispatch = useDispatch();

    const setEditorHandle = (editor?: Editor) => {
        setEditor(editor)
    }

    const setOpenHistoryTabHandle = (n: number) => {
        setOpenHistoryTab(n)
    }
    const clientId = userInfo?.uuid

    const [boardInfo, setBoardInfo] = useState<caseBoardInfoProps | null>(null)



    useEffect(() => {
        let lang = getLocalStorage('i18nextLng')
        if (lang === 'zh') lang = 'zh-cn'
        editor && editor.user.updateUserPreferences({ locale: lang })
    }, [editor]);

/*    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = '.tl-watermark_SEE-LICENSE { display: none !important; }';
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);*/

    const controlHistory = (id: number) => {
        setOpenHistoryTab(id)
    }

    useEffect(() => {
        setOpenHistoryTab(0)
    }, [level2TaskId]);


    useEffect(() => {
        if (!editor) return;

        // 初始化居中显示
        editor.zoomToFit({ animation: { duration: editor.options.animationMediumMs } })

    }, [editor]);

    useEffect(() => {
        if(boardId) {
            getBoardInfo(boardId).then(info => {
                if(info) setBoardInfo(info)
            })
        }
    }, [boardId]);

    // user config is initialized globally in App

    return (
        <div style={{display: 'flex'}}>
            {
                <div className='home pc-only'>
                    <div className='home-icon' onClick={() => {
                        dispatch(coverSelectCanvasImage(null))
                        dispatch(setCurrentDialogImageInfo(null))
                        dispatch(setCurrentImageShape(null))
                        dispatch(setGlobalMessage(''));
                        dispatch(setCurrentStepId(''));
                        if (userInfo){
                            navigate('/dashboard')
                        }else {
                            navigate('/dashboard/home')
                        }
                    }}><HomeIcon/></div>
                    <div className='board-name'>{boardInfo?.boardName}</div>
                </div>
            }
            {
                !IsVisitor() &&
                <div className="profile-wrapper flex-col-reverse" style={{right: openHistoryTab ? '20.5%' : 10, display: 'flex'}}><Profile
                    editor={editor} boardInfo={boardInfo}/></div>
            }
            {!userInfo && <NewUser  register_from='board_register_button'/>}
            <CustomerService/>
            <NotificationService />
            <div style={{
                position: 'fixed',
                inset: 0,
                display: (clientId || IsVisitor()) ? 'display' : 'none',
                width: openHistoryTab ? '80%' : '100%'
            }}>
                {/*              {
                    userInfo && <div style={{position: "absolute", top: 20, left: "160px", zIndex: 1, fontSize: 12}}>
                        欢迎您，{userInfo.nickName}， <span onClick={loginOut} style={{textDecoration: "underline", cursor: 'pointer'}}>退出</span>
                    </div>
                }*/}

                {
                    <Button
                            disabled={GuestMode === 'guest'}
                            style={{top: '18px', right: "260px", zIndex: 1, position: 'absolute', display: 'none'}}
                            variant="contained" onClick={() => {
                        dispatch(setChangeGuestMode('guest'))
                    }}>访客模式</Button>
                }

                {
                    <Button loading={loading}
                            style={{top: '10px', right: "10px", zIndex: 1, position: 'absolute', display: 'none'}}
                            variant="contained" onClick={() => {
                        setLoading(true)
                        const snapshot = editor?.store.getSnapshot();
                        const jsonString = JSON.stringify(snapshot);
                        uploadCanvasJson(clientId as string, jsonString).then((res) => {
                            setLoading(false)
                            notificationService.show('当前画布保存成功!', 'success');
                        });
                    }}>保存当前画板</Button>
                }
                {/*                {
                    <Button loading={loading} style={{ top: '10px', right: "10px", zIndex: 1, position: 'absolute'}} variant="contained" onClick={()=>{
                       // @ts-ignore
                       setLabelToFrameNotDependent(CommandType.CHAT, 266551, '基于上传图片进行分析')
                       console.log('创建子容器到中心点')
                    }}>保存当前画板</Button>
                }
                {
                    <Button loading={loading} style={{ top: '10px', right: "150px", zIndex: 1, position: 'absolute'}} variant="contained" onClick={()=>{
                        replaceDescribeFrame(266551, '听起来您对某个视觉元素有点疑惑', CommandType.CHAT)
                    }}>替换对话节点</Button>
                }*/}
                {
                    level2TaskId && <Button
                        loading={loading}
                        style={{top: '15px', left: "160px", zIndex: 1, position: 'absolute'}}
                        variant="contained"
                        startIcon={<ArrowBackIosIcon/>}
                        onClick={() => {
                            window.location.reload();
                        }}
                    >
                        {t('exit_task')}
                    </Button>
                }
                {
                    isInspire ? <RemoteInspireBoardComponent userInfo={userInfo} /> : <LocalMoodBoardComponent
                        boardInfo={boardInfo}
                        setEditorHandle={setEditorHandle}
                        userInfo={userInfo}
                        setOpenHistoryTabHandle={setOpenHistoryTabHandle}
                        openHistoryTab={openHistoryTab}
                        editor={editor}/>
                }
            </div>
        </div>
    )
}
